import React from "react"
import { css, keyframes } from "styled-components"

const enter = keyframes`
  0% {
    opacity: 0;
    margin-right: 70px;
  }

  50% {
    opacity: 0;
    margin-right: 70px;
  }

  100% {
    opacity: 1;
    margin-right: 0px;
  }
`

const enterHeart = keyframes`
  0% {
    opacity: 0;
    scale: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

const styles = css`
  animation: ${enter} 4s linear;
  animation-fill-mode: forwards;
`

export default () => {
  return (
    <div
      css={`
        margin: 20px 0;
        scale: 1.3;
      `}
    >
      <svg
        css={styles}
        width="65px"
        height="62px"
        viewBox="0 0 65 62"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M4.288 14.41c-5.66 8.14-4.96 18.728-.632 27.4.1.208.21.412.316.616l.2.39c.04.076.084.15.126.224.074.14.15.268.226.404l.414.708.236.388.48.75.204.316c.226.336.456.672.694 1l.136.184c.206.283.417.563.632.84l.24.304.584.72.224.268c.266.314.54.626.814.93.028.03.04.04.048.052.272.295.548.585.828.872l.266.268.66.648.27.26c.297.28.6.555.906.824l.992.84.34.272.686.536.366.28.77.552.36.254c.246.17.496.332.748.494l.324.216c.386.245.776.484 1.17.716l.324.2.88.492c.16.086.324.168.486.25l.628.326.146.07.26.124.996.46.21.094c.384.167.772.328 1.162.482l.28.112 1.096.406.14.048c.405.14.811.273 1.22.4l.296.088c.4.126.832.28 1.26.356 27.388 4.994 35.34-16.46 35.34-16.46-6.68 8.704-18.54 11-29.8 8.444-.426-.096-.84-.228-1.254-.352l-.312-.094a37.24 37.24 0 0 1-1.208-.394l-.166-.06a41.74 41.74 0 0 1-1.064-.394l-.3-.12a30.32 30.32 0 0 1-1.15-.48l-.23-.1-.97-.452-.28-.134c-.252-.12-.5-.254-.75-.4l-.5-.26c-.304-.16-.6-.332-.9-.504l-.304-.17a43.52 43.52 0 0 1-1.17-.716c-.106-.068-.21-.14-.316-.21l-.832-.554c-.092-.06-.2-.128-.268-.188l-.788-.57-.35-.264-.71-.556-.316-.254-.884-.746a1.46 1.46 0 0 0-.1-.08l-.93-.846-.26-.252-.664-.66-.26-.26c-.28-.286-.552-.574-.8-.868-.014-.014-.028-.028-.04-.044a33.96 33.96 0 0 1-.832-.948l-.2-.26-.6-.74-.2-.274-.692-.92c-6.276-8.504-8.52-20.26-3.532-29.9m13.16-1.25c-4.096 5.894-3.874 13.8-.68 20.016A26.12 26.12 0 0 0 23 30.594c.614.88 1.294 1.926 2.108 2.632.296.326.604.64.92.954l.24.24c.306.298.618.589.938.872.014.01.024.024.04.034.364.32.732.6 1.106.916l.248.194c.375.29.758.569 1.148.838l.034.024c.172.12.348.23.524.346.084.054.164.112.248.164.28.18.563.353.85.52l.12.07.752.4c.088.05.2.092.268.14l.526.272c.026.014.054.024.08.036.36.18.726.35 1.096.51l.24.1c.298.126.598.248.9.364l.384.14c.274.1.55.195.826.286l.374.12c.394.12.8.28 1.194.346 21.146 3.504 26.028-12.8 26.028-12.8-4.4 6.34-12.92 9.36-22.016 7a26.12 26.12 0 0 1-1.198-.346c-.12-.036-.24-.076-.36-.116l-.84-.288-.4-.14a30.16 30.16 0 0 1-.9-.364l-.244-.1a25.16 25.16 0 0 1-1.104-.512l-.554-.28-.32-.164a26.32 26.32 0 0 1-.7-.394l-.168-.094a24.68 24.68 0 0 1-.848-.52c-.086-.054-.17-.114-.256-.17l-.55-.364a26.48 26.48 0 0 1-1.14-.836l-.26-.2c-4-3.144-7.136-7.44-8.636-12.308-1.572-5.05-1.234-10.72 1.49-15.32m11.464-.366C34.24 6 34 10.396 35.676 14.32c1.766 4.166 5.386 7.432 9.612 9l.524.2.232.072.754.2c11.676 2.256 14.84-5.992 15.686-7.206-2.774 3.994-7.436 4.952-13.156 3.564-.452-.11-.948-.274-1.384-.428a16.92 16.92 0 0 1-1.644-.682 17 17 0 0 1-2.882-1.758C38.3 13.4 35.12 5.972 38.46-.06"
          fill="#0868AC"
          fillRule="nonzero"
        />
      </svg>
      <svg
        css={`
          position: absolute;
          margin-left: -19px;
          margin-top: 13px;
          z-index: 99;
          scale: 1.2;
          animation: ${enter} 6s linear;
          animation-fill-mode: forwards;
        `}
        width="46px"
        height="40px"
        viewBox="0 0 46 40"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M34.044.298c-.44 0-.9.029-1.491.093l-.009.002h-.009c-4.36.554-7.928 3.44-9.531 7.302A11.943 11.943 0 0 0 13.312.369h-.004c-.419-.046-.887-.07-1.352-.07C5.363.298 0 5.662 0 12.255c0 .421.007.913.084 1.353a12.03 12.03 0 0 0 2.219 5.702c.03.042.063.081.1.118l19.801 19.979a1.001 1.001 0 0 0 1.42 0l20.361-20.544c.049-.049.092-.103.13-.161a11.766 11.766 0 0 0 1.793-4.942c.042-.408.092-.947.092-1.505C46 5.662 40.637.298 34.044.298z"
          fill="#D10B0B"
          fillRule="nonzero"
        />
      </svg>

      <svg
        css={styles}
        width="65px"
        height="59px"
        viewBox="0 0 65 59"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M53.451 19.206a43.52 43.52 0 0 0-2.092-.66c.118-.482.226-.958.323-1.426 1.584-7.689.548-13.883-2.988-15.922-3.391-1.956-8.937.083-14.537 4.957-.539.469-1.079.965-1.619 1.485a39.74 39.74 0 0 0-1.077-.994c-5.87-5.212-11.753-7.408-15.286-5.363-3.388 1.96-4.391 7.784-2.965 15.07.137.704.298 1.423.48 2.154-.832.236-1.636.488-2.405.756-6.882 2.4-11.277 6.16-11.277 10.06 0 4.028 4.718 8.069 11.886 10.518.565.194 1.152.377 1.757.55-.196.79-.367 1.565-.51 2.32-1.36 7.16-.298 12.846 3.08 14.795 3.49 2.012 9.347-.057 15.05-5.042.451-.394.904-.812 1.357-1.25.587.566 1.174 1.101 1.757 1.603 5.524 4.754 10.98 6.674 14.356 4.72 3.486-2.019 4.62-8.126 3.148-15.557a36.746 36.746 0 0 0-.39-1.737c.412-.122.816-.247 1.21-.378 7.45-2.469 12.299-6.46 12.299-10.542 0-3.915-4.537-7.7-11.557-10.117zM51.835 37.23c-.355.118-.72.232-1.092.342-.822-2.604-1.933-5.374-3.291-8.235 1.296-2.793 2.364-5.526 3.163-8.114.665.193 1.31.395 1.932.61 6.015 2.07 9.684 5.132 9.684 7.49 0 2.513-3.962 5.775-10.396 7.907zm-2.67 5.29c.65 3.286.744 6.257.313 8.579-.387 2.087-1.166 3.478-2.129 4.035-2.048 1.186-6.429-.355-11.153-4.42a39.861 39.861 0 0 1-1.634-1.491c1.831-2.003 3.662-4.332 5.448-6.918 3.142-.279 6.111-.735 8.803-1.357.133.535.25 1.06.352 1.572zM22.168 54.93c-2.001.706-3.595.727-4.559.171-2.05-1.183-2.903-5.747-1.74-11.87.133-.702.292-1.422.474-2.159 2.663.59 5.61 1.013 8.76 1.268 1.799 2.53 3.682 4.857 5.58 6.894-.415.4-.828.781-1.239 1.14-2.521 2.205-5.049 3.769-7.276 4.555zm-9.376-17.715c-3.17-1.083-5.787-2.491-7.581-4.028-1.612-1.38-2.426-2.75-2.426-3.863 0-2.367 3.528-5.386 9.414-7.438a40.018 40.018 0 0 1 2.237-.704c.813 2.646 1.88 5.412 3.168 8.21-1.304 2.838-2.386 5.649-3.208 8.325a34.275 34.275 0 0 1-1.604-.502zm3.143-21.394c-1.222-6.243-.41-10.952 1.631-12.134 2.175-1.259 6.983.536 12.051 5.036.324.288.65.589.976.9-1.889 2.028-3.755 4.337-5.538 6.853-3.057.283-5.983.738-8.673 1.347-.17-.68-.32-1.348-.447-2.002zm28.038 6.923a88.372 88.372 0 0 0-1.977-3.25c2.074.262 4.061.61 5.927 1.036a59.278 59.278 0 0 1-2.08 5.597 96.558 96.558 0 0 0-1.87-3.383zM32.539 11.607a59.333 59.333 0 0 1 3.825 4.617 81.762 81.762 0 0 0-7.682-.001 61.244 61.244 0 0 1 3.857-4.616zM21.032 22.762a82.027 82.027 0 0 0-1.835 3.362 61.287 61.287 0 0 1-2.065-5.625 62.583 62.583 0 0 1 5.893-1.011 81.723 81.723 0 0 0-1.993 3.274zm2.052 16.594a59.12 59.12 0 0 1-5.99-.963 62.34 62.34 0 0 1 2.106-5.739 82.292 82.292 0 0 0 3.884 6.702zm9.532 7.879a62.316 62.316 0 0 1-3.911-4.68c1.245.048 2.513.073 3.803.073 1.325 0 2.635-.03 3.924-.087a59.066 59.066 0 0 1-3.816 4.694zm13.253-14.68a58.925 58.925 0 0 1 2.183 5.717 58.99 58.99 0 0 1-6.063 1.034A97.183 97.183 0 0 0 43.984 36a88.358 88.358 0 0 0 1.885-3.444zm-4.29 2.056a91.145 91.145 0 0 1-3.118 5.032 83.755 83.755 0 0 1-5.953.208c-2.023 0-3.99-.062-5.885-.185a78.829 78.829 0 0 1-3.177-5.04 77.964 77.964 0 0 1-2.773-5.237 78.767 78.767 0 0 1 2.765-5.24 78.108 78.108 0 0 1 3.151-5.017 78.725 78.725 0 0 1 5.919-.222c2.012 0 3.997.077 5.93.224a83.554 83.554 0 0 1 3.132 5 91.15 91.15 0 0 1 2.802 5.216 83.725 83.725 0 0 1-2.793 5.261zm5.728-31.008c2.177 1.256 3.023 6.318 1.655 12.956a36.49 36.49 0 0 1-.292 1.292c-2.696-.622-5.625-1.085-8.69-1.373-1.787-2.543-3.638-4.855-5.495-6.857.5-.48.998-.939 1.495-1.371 4.798-4.176 9.283-5.825 11.327-4.647zM32.508 23.518a5.804 5.804 0 1 1 0 11.61 5.804 5.804 0 0 1 0-11.61z"
          fill="#00D8FF"
          fillRule="nonzero"
        />
      </svg>
    </div>
  )
}
